<script setup>
  import {
    computed,
    onMounted,
    ref,
  } from 'vue'

  import List from './List.vue'
  import Loading from '@components/Loading.vue'
  import MapView from './MapView.vue'
  import ModalMessage from '@components/ModalMessage.vue'
  import Property from '@components/PropertyLarge.vue'

  import { useI18n } from '@shared/i18n.js'
  import { useAjax } from '@composables/useAjax.js'
  import { usePropertySearch } from '@composables/usePropertySearch.js'
  import { useBookmarkProperty } from '@composables/useBookmarkProperty.js'
  import { usePropertiesEnquiry } from '@composables/usePropertiesEnquiry.js'
  import { useWatchWindowSize } from '@composables/useWatchWindowSize.js'
  import { useStore } from './useStore.js'
  import {
    generateUrl,
    shuffleArray
  } from '@shared/util.js'

  const {
    Modes,
    getViewMode,
    saveViewMode,
    switchViewMode,
  } = usePropertySearch()

  const banners = ref(null)
  const mode = ref(Modes.LIST)

  const {
    agents,
    title
  } = window.app.page

  const store = useStore()

  const { vt } = useI18n('properties.index.js')
  const { callGet } = useAjax()
  const { getBookmarks } = useBookmarkProperty()
  const { overSelected, selected } = usePropertiesEnquiry()
  const { isMobileSize } = useWatchWindowSize()

  onMounted(() => {
    const url = new URL(window.location.href)
    if (getViewMode()) {
      mode.value = getViewMode()
    }
    else if (url.searchParams.get('m') == 't') {
      mode.value = Modes.MAP
    }
    /*
    else if (window.innerWidth > 768 && url.searchParams.get('m') != 'f') {
      mode.value = Modes.MAP
    }
    */

    if (mode.value === Modes.LIST) {
      /*
      url.searchParams.delete('m')
      url.searchParams.append('m', 'f')
      history.replaceState({}, '', url.toString())
      */
      document.querySelector('body').classList.remove('property_list_map')
      document.querySelector('.p-property-for-links').classList.remove('page-map')
      document.querySelector('.p-property-for-links').classList.add('map')
    }
    else {
      url.searchParams.delete('m')
      url.searchParams.append('m', 't')
      history.replaceState({}, '', url.toString())
    }

    saveViewMode(mode.value)
    store.getProperties()
    getBanners()
    getBookmarks()

    if (isMapView.value) {
      setTimeout(() => {
        const element = document.querySelector('.result_map_left')
        const child = document.querySelector('.p-introduction-block')
        if (child) {
          element.appendChild(child)
        }
        element.appendChild(document.querySelector('.p-property-for-links'))
        element.appendChild(document.querySelector('.c-breadcrumb'))
        element.appendChild(document.querySelector('footer'))
      }, 500)
    }
  })

  const isListView = computed(() => mode.value == Modes.LIST)
  const isMapView = computed(() => mode.value == Modes.MAP)

  /**
   * バナーの取得
   */
  const getBanners = async () => {
    if (agents) {
      banners.value = { large: [], top: [] }
      return
    }

    const url = generateUrl('banners/properties')
    url.searchParams.append("u", window.app.common.cacheKey.banner)
    const response = await callGet(url.toString())
    banners.value = response.banners
    setBanners()
  }

  /**
   * 一覧の表示更新
   */
  const handleRefresh = () => {
    setBanners()
    const element = document.querySelector('.p-introduction-block')
    if (element) {
      element.classList.remove('hide')
    }
    document.querySelector('.p-property-for-links').classList.remove('hide')
    document.querySelector('.c-breadcrumb').classList.remove('hide')
  }

  /**
   * バナーの設定
   */
  const setBanners = () => {
    if (!banners.value.large) return

    banners.value = {
      large: shuffleArray([...banners.value.large]),
      top: shuffleArray([...banners.value.top]),
    }
  }
</script>

<template>
  <!-- マップに表示する用 -->
  <div v-if="isMapView" v-show="store.activeProperty && isMobileSize" id="property-dummy">
    <div class="listing map-info">
      <Property
        v-if="store.activeProperty"
        :action="false"
        :max-images-count="1"
        :property="store.activeProperty"
        :selectable="false"
        id-custom="property-dummy-card"
      />
    </div>
  </div>

  <div :class="{ result_map: isMapView }">
    <div :class="{ result_map_left: isMapView }">
      <div id="body">
        <div id="main">
          <div class="l-wrap">
            <article>
              <h1 class="c-ttl">{{ title }}</h1>

              <template v-if="store.properties && banners">
                <List
                  :banners="banners"
                  :is-list-view="isListView"
                  @refresh="handleRefresh"
                />
              </template>
              <template v-else>
                <Loading style="margin-top: 100px;" />
              </template>
            </article>
          </div>
        </div>
      </div>
    </div>

    <MapView v-if="isMapView" />

    <ul v-if="isListView || !isMobileSize || !store.activeProperty" class="switch_btn" id="switch_btn">
      <li :class="{ 'is-active': selected.length > 0 }" class="map_btn">
        <a href="" @click.prevent.stop="switchViewMode()">
          <template v-if="isListView">
            <i class="fas fa-map-marker-alt"></i>MAP
          </template>
          <template v-else>
            <i class="fa-solid fa-list"></i>LIST
          </template>
        </a>
      </li>
    </ul>

    <ModalMessage
      v-model="overSelected"
      :message="vt('over_selected')"
    />
  </div>
</template>

<style>
  .slick-slide {
    height: auto;
  }
</style>
